import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class IncorrectPaymentTransaction extends ModelBase {
  constructor() {
    super();

    Object.defineProperties(this, {
      _businessTransactionDate: { enumerable: false, writable: true },
      _creationDate: { enumerable: false, writable: true },
    });
  }

  private _businessTransactionDate: LocalDate;

  get businessTransactionDate(): LocalDate {
    return this._businessTransactionDate;
  }
  set businessTransactionDate(value: LocalDate) {
    this._businessTransactionDate = LocalDate.fromDate(value);
  }

  private _creationDate: LocalDate;

  get creationDate(): LocalDate {
    return this._creationDate;
  }
  set creationDate(value: LocalDate) {
    this._creationDate = LocalDate.fromDate(value);
  }

  amount: Money;
  description: string;
  verificationNumber: string;
}
